// @ts-ignore

import { css } from '@compiled/react';
import { useIntl } from 'react-intl';

import { useAnalyticsEvents } from '@atlaskit/analytics-next';

import { wacToken } from '@/libraries/design/foundations';

import * as messages from '../messages.ts';

import { PriceAltContainer } from './price-alt-container.tsx';

export interface MonthlyEnterpriseMessageProps {
	switchToAnnual: () => void;
}

export const MonthlyEnterpriseMessage = (props: MonthlyEnterpriseMessageProps) => {
	const { switchToAnnual } = props;
	const intl = useIntl();
	const { createAnalyticsEvent } = useAnalyticsEvents();

	const handleClick = () => {
		createAnalyticsEvent({
			eventType: 'ui',
			action: 'clicked',
			actionSubject: 'button',
			actionSubjectId: 'switchToAnnual',
			source: 'pricingCalculator',
			attributes: { label: 'billed annually' },
		}).fire();
		switchToAnnual();
	};

	return (
		<PriceAltContainer>
			<button css={buttonCss} type="button" onClick={handleClick} tabIndex={0}>
				{intl.formatMessage(messages.billedAnnually)}
			</button>
			&nbsp;
			{intl.formatMessage(messages.switchToAnnualToViewEnterprise)}
		</PriceAltContainer>
	);
};

const buttonCss = css({
	background: 'transparent',
	border: 0,
	cursor: 'pointer',
	color: wacToken('color.primary.blue'),
	fontFamily: 'inherit',
	fontSize: 'inherit',
	lineHeight: 0,
	padding: 0,
	textOverflow: 'ellipsis',
	textDecoration: 'underline',
	whiteSpace: 'nowrap',
	':hover': {
		color: wacToken('color.extended.blue800'),
	},
});
